/**
 * logTriage · «найди сигнал в шуме» (S17 · T05). Per ADR-015.
 * В шумном CI-логе студент кликает строку с НАСТОЯЩЕЙ ошибкой (data-sig="1");
 * остальное — шум установки/служебное (data-sig="0"). Верный клик подсвечивает
 * причину и раскрывает AI-выжимку (data-ai). Промахи считаются.
 *
 * Контракт разметки:
 *   <div class="log-triage" data-fin="мораль" data-ai="AI-выжимка текстом">
 *     <div class="lt-head"><span class="lt-ttl">…</span>
 *       <span class="lt-cnt">промахов <b class="lt-miss">0</b></span></div>
 *     <div class="lt-instr">Кликни строку, где настоящая ошибка…</div>
 *     <pre class="lt-log"><span class="lt-line" data-sig="0">шум</span>
 *   <span class="lt-line" data-sig="1">ModuleNotFoundError: …</span></pre>
 *     <div class="lt-verdict" aria-live="polite"></div>
 *     <div class="lt-ai"><div class="lt-ai-h">AI-выжимка</div><div class="lt-ai-text"></div></div>
 *   </div>
 *
 * No-JS: лог читается целиком. StrictMode-safe (guard + cleanup восстанавливает innerHTML).
 */
export function initLogTriage(root: HTMLElement): () => void {
  if (typeof document === 'undefined') return () => {};
  const cleanups: Array<() => void> = [];

  root.querySelectorAll<HTMLElement>('.log-triage').forEach((el) => {
    if (el.dataset.ltInit === '1') return;
    el.dataset.ltInit = '1';
    const original = el.innerHTML;

    const lines = Array.from(el.querySelectorAll<HTMLElement>('.lt-line'));
    const verdict = el.querySelector<HTMLElement>('.lt-verdict');
    const ai = el.querySelector<HTMLElement>('.lt-ai');
    const aiText = el.querySelector<HTMLElement>('.lt-ai-text');
    const missEl = el.querySelector<HTMLElement>('.lt-miss');
    if (lines.length === 0) return;

    el.classList.add('lt-ready');
    let solved = false;
    let misses = 0;

    const onLine = (e: Event) => {
      if (solved) return;
      const ln = e.currentTarget as HTMLElement;
      if (ln.dataset.sig === '1') {
        solved = true;
        lines.forEach((l) => {
          if (l.dataset.sig === '1') l.classList.add('lt-hit');
        });
        if (aiText) aiText.textContent = el.dataset.ai ?? '';
        ai?.classList.add('lt-show');
        if (verdict) {
          verdict.textContent = el.dataset.fin || 'Это и есть причина — остальное шум установки.';
          verdict.className = 'lt-verdict lt-ok-msg';
        }
      } else {
        ln.classList.add('lt-miss-line');
        misses += 1;
        if (missEl) missEl.textContent = String(misses);
        if (verdict) {
          verdict.textContent = 'Это шум (установка или служебное). Ищи строку с самой ошибкой.';
          verdict.className = 'lt-verdict lt-err-msg';
        }
      }
    };

    lines.forEach((l) => {
      l.setAttribute('role', 'button');
      l.tabIndex = 0;
      l.addEventListener('click', onLine);
    });

    cleanups.push(() => {
      lines.forEach((l) => l.removeEventListener('click', onLine));
      el.innerHTML = original;
      el.classList.remove('lt-ready');
      delete el.dataset.ltInit;
    });
  });

  return () => cleanups.forEach((fn) => fn());
}
